/**
 * HOW REPOSITORY FACTORY WORKS
 * RepositoryFactory it's gonna be defined at build time.
 * How? Webpack is gonna check for API_CALLS environment variable
 * and based on it, it's gonna define the RepositoryFactory "get" property
 * dynamically.
 * If we're able to make API_CALLS, it's gonna get the real repositories listed
 * at the repositories object and if not, it's gonna take the mocked repositories
 * listed at the mockRepositories.
 * This way, we will be able to seamlessly import { someRepository } from '@/forms/api/repository'
 * and if we can do real API calls, it's gonna take the real repos and if not,
 * it's gonna take the mocks.
 * Sidenote: The things that won't be used, webpack will tree-shake 'em so we wont't
 * end up with bytes we may not need.
 */

import axios from "axios";

// API REPOSITORIES
import DecisionRepository from "@/forms/api/repository/decision-repository";
import FormRepository from "@/forms/api/repository/form-repository";
import OtpRepository from "@/forms/api/repository/otp-repository";
import CompaniesRepository from "@/forms/api/repository/companies-repository";
//Begin Code modified by Attra for Release 1.0 on 10-OCT-2019
import CifRepository from "@/forms/api/repository/cif-repository";
import CifUpdateRepository from "@/forms/api/repository/cif-update-repository";
import LeadCreationRepository from "@/forms/api/repository/lead-creation-repository";
import workEmailValidateRepository from "@/forms/api/repository/work-email-validate-repository";
import personalEmailValidateRepository from "@/forms/api/repository/personal-email-validate-repository";
import IncomeUpdateRepository from "@/forms/api/repository/income-update-repository";
import CreditScorCalculationeRepository from "@/forms/api/repository/credit-score-calculation-repository";
import CreditReportRepository from "@/forms/api/repository/credit-report-repository";
import SrCreateRepository from "@/forms/api/repository/sr-create-repository";
import LeadSquardedRepository from "@/forms/api/repository/lead-squarded-repository";
import ValidatePromoCodeRepository from "@/forms/api/repository/validate-pomo-code-repository";
import BranchDetailsRepository from "@/forms/api/repository/branch-details-repository";
import AppianPersonalInfoRepository from "@/forms/api/repository/appian-personal-info-repository";
import AppianEmpInfoRepository from "@/forms/api/repository/appian-emp-info-repository";
import AppianIncomeInfoRepository from "@/forms/api/repository/appian-income-info-repository";
import AppianIdentityInfoRepository from "@/forms/api/repository/appian-identity-info-repository";
import AccuityRepository from "@/forms/api/repository/accuity-repository";
import CreditCCScoreRepository from "@/forms/api/repository/credit-cc-score-repository";
import InsuranceRepository from "@/forms/api/repository/insurance-repository";
import CustomerExistRepository from "@/forms/api/repository/customer-exist-repository";
import ReferralDataRepository from "@/forms/api/repository/referral-data-repository";
import AccuitySupplementaryRepository from "@/forms/api/repository/accuity-supplementary-repository";
//End Code modified by Attra for Release 1.0 on 10-OCT-2019
import CreateAddressRepository from "@/forms/api/repository/create-address-repository";
import CreditScoreRepository from "@/forms/api/repository/credit-score-repository";
import MonthlyInstalmentRepository from "@/forms/api/repository/monthly-instalment-repository";
import TransactionRepository from "@/forms/api/repository/transaction-repository";
import UploadRepository from "@/forms/api/repository/upload-repository";
import PerfioDocumentRepository from "@/forms/api/repository/bank-perfio-repository";
import InstitutionsRepository from "@/forms/api/repository/institutions-repository";
import BanksRepository from "@/forms/api/repository/get-bank-names-repository";
import CrmContactValidateRepository from "@/forms/api/repository/crm-contact-validation-repository";
import EmailNotificationRepository from "@/forms/api/repository/emailnotification-repository";
import MerchantNotificationRepository from "@/forms/api/repository/merchant-email-repository.js";
import AutomationApiRepository from "@/forms/api/repository/automation-api-repository";
import AutoLoanDetailsRepository from "@/forms/api/repository/auto-loan-details-repository";
import CreditScorCalculationDigitalRepository from "@/forms/api/repository/credit-score-cal-digital-repository";
//crmContactValidateRepository
// MOCK REPOSITORIES
import DecisionMock from "@/forms/api/mock/decision-mock";
import FormMock from "@/forms/api/mock/form-mock";
import OtpMock from "@/forms/api/mock/otp-mock";
import CompaniesMock from "@/forms/api/mock/companies-mock";
import CreditScoreMock from "@/forms/api/mock/credit-score-mock";
import MonthlyInstalmentMock from "@/forms/api/mock/monthly-instalment-mock";
import TransactionMock from "@/forms/api/mock/transaction-mock";
import UploadMock from "@/forms/api/mock/upload-mock";
import PerfioDocumentMock from "@/forms/api/mock/bank-perfio-mock";
import InstitutionsMock from "@/forms/api/mock/institutions-mock";

// Detect if we're able to do API calls
const API_CALLS = !!process.env.VUE_APP_API_CALLS;
// Get the END_POINT from the environment variables
const END_POINT = process.env.VUE_APP_END_POINT;
const END_POINT_APPIAN = process.env.VUE_APP_END_POINT_APPIAN;
// Build a base URI with it
const baseURL = `${END_POINT}/`;
const baseURLAppian = "https://deemdev.appiancloud.com/";
const randomId = 300;
const headers = {
  // 'Access-Control-Allow-Origin': '*',
  // 'Access-Control-Allow-Methods': `GET, PUT, POST, DELETE, OPTIONS, post, get`,

  // 'Access-Control-Allow-Headers': `Origin, Content-Type, X-Auth-Token`,

  consumerApp: "dunia_onb_svc_prod",
  Authorization:
    "Basic MzRiOWZjNjZkNzlhNDhlNjhmMmFiYzg0Zjg5ZjEzMTM6OTIzNTM5ZGNFNWE0NDM0OUIyOTJEMzJhZDlFMGVBZUE=",
  consumerTransId: `random-trans-id-${randomId}`,
  DuniaAuthorization: "false"
};

// Our repositories object
const repositories = {
  decision: DecisionRepository,
  forms: FormRepository,
  otp: OtpRepository,
  companies: CompaniesRepository,
  //Begin Code modified by Attra for Release 1.0 on 10-OCT-2019
  cif: CifRepository,
  cifUpdate: CifUpdateRepository,
  leadCreation: LeadCreationRepository,
  workEmailValidate: workEmailValidateRepository,
  incomeUpdate: IncomeUpdateRepository,
  creditScoreCalculation: CreditScorCalculationeRepository,
  creditReport: CreditReportRepository,
  srCreate: SrCreateRepository,
  leadSquarded: LeadSquardedRepository,
  personalEmailValidate: personalEmailValidateRepository,
  validatePromoCode: ValidatePromoCodeRepository,
  branchDetails: BranchDetailsRepository,
  appianPersonalInfo: AppianPersonalInfoRepository,
  appianEmpInfo: AppianEmpInfoRepository,
  appianIncomeInfo: AppianIncomeInfoRepository,
  appianIdentityInfo: AppianIdentityInfoRepository,
  //End Code modified by Attra for Release 1.0 on 10-OCT-2019
  createAddress: CreateAddressRepository,
  accuity: AccuityRepository,
  creditScore: CreditScoreRepository,
  monthlyInstalment: MonthlyInstalmentRepository,
  transaction: TransactionRepository,
  upload: UploadRepository,
  perfioDocument: PerfioDocumentRepository,
  institutions: InstitutionsRepository,
  creditCCScore: CreditCCScoreRepository,
  insurance: InsuranceRepository,
  customerExist: CustomerExistRepository,
  referralData: ReferralDataRepository,
  accuitySupplementary: AccuitySupplementaryRepository,
  bankNames: BanksRepository,
  crmContactValidate: CrmContactValidateRepository,
  emailNotification: EmailNotificationRepository,
  merchantNotification: MerchantNotificationRepository,
  automationApi: AutomationApiRepository,
  autoLoanDetails: AutoLoanDetailsRepository,
  creditScoreCalculationDigital: CreditScorCalculationDigitalRepository
};

// Our mock repositories object
const mockRepositories = {
  decision: DecisionMock,
  forms: FormMock,
  otp: OtpMock,
  companies: CompaniesMock,
  creditScore: CreditScoreMock,
  monthlyInstalment: MonthlyInstalmentMock,
  transaction: TransactionMock,
  upload: UploadMock,
  perfioDocument: PerfioDocumentMock,
  institutions: InstitutionsMock
};

let repositoryFactory;

if (API_CALLS) {
  repositoryFactory = repositories;
} else {
  repositoryFactory = mockRepositories;
}

// Generate a variable that we will use to generate axios calls
// later on inside a RespositoryFactory
const Repository = axios.create({ baseURL, headers, timeout: 90000 });
const otpRepository = repositoryFactory.otp;
const formRepository = repositoryFactory.forms;
const companiesRepository = repositoryFactory.companies;
const decisionRepository = repositoryFactory.decision;
//Begin Code modified by Attra for Release 1.0 on 10-OCT-2019
const cifRepository = repositoryFactory.cif;
const cifUpdateRepository = repositoryFactory.cifUpdate;
const leadCreationRepository = repositoryFactory.leadCreation;
const workEmailRepository = repositoryFactory.workEmailValidate;
const incomeUpdateRepository = repositoryFactory.incomeUpdate;
const creditScorCalculationeRepository = repositoryFactory.creditScoreCalculation;
const creditReportRepository = repositoryFactory.creditReport;
const srCreateRepository = repositoryFactory.srCreate;
const leadSquardedRepository = repositoryFactory.leadSquarded;
const personalEmailRepository = repositoryFactory.personalEmailValidate;
const promoCodeRepository = repositoryFactory.validatePromoCode;
const branchDetailsRepository = repositoryFactory.branchDetails;
const appianPersonalInfoRepository = repositoryFactory.appianPersonalInfo;
const appianEmpInfoRepository = repositoryFactory.appianEmpInfo;
const appianIncomeInfoRepository = repositoryFactory.appianIncomeInfo;
const appianIdentityInfoRepository = repositoryFactory.appianIdentityInfo;
//End Code modified by Attra for Release 1.0 on 10-OCT-2019
const createAddressRepository = repositoryFactory.createAddress;
const accuityRepository = repositoryFactory.accuity;
const creditScoreRepository = repositoryFactory.creditScore;
const monthlyInstalmentRepository = repositoryFactory.monthlyInstalment;
const transactionRepository = repositoryFactory.transaction;
const uploadRepository = repositoryFactory.upload;
const perfioDocumentRepository = repositoryFactory.perfioDocument;
const institutionsRepository = repositoryFactory.institutions;
const creditCCScoreRepository = repositoryFactory.creditCCScore;
const insuranceRepository = repositoryFactory.insurance;
const customerExistRepository = repositoryFactory.customerExist;
const referralDataRepository = repositoryFactory.referralData;
const accuitySupplementaryRepository = repositoryFactory.accuitySupplementary;
const bankNamesRepository = repositoryFactory.bankNames;
const crmContactValidateRepository = repositoryFactory.crmContactValidate;
const emailNotificationRepository = repositoryFactory.emailNotification;
const merchantNotificationRepository = repositoryFactory.merchantNotification;
const automationApiRepository = repositoryFactory.automationApi;
const autoLoanDetailsRepository = repositoryFactory.autoLoanDetails;
const creditScorCalculationDigitalRepository = repositoryFactory.creditScoreCalculationDigital;
export {
  otpRepository,
  formRepository,
  companiesRepository,
  decisionRepository,
  cifRepository,
  cifUpdateRepository,
  leadCreationRepository,
  creditScoreRepository,
  monthlyInstalmentRepository,
  transactionRepository,
  uploadRepository,
  perfioDocumentRepository,
  institutionsRepository,
  Repository,
  workEmailRepository,
  personalEmailRepository,
  incomeUpdateRepository,
  creditScorCalculationeRepository,
  creditReportRepository,
  srCreateRepository,
  leadSquardedRepository,
  promoCodeRepository,
  branchDetailsRepository,
  appianPersonalInfoRepository,
  appianEmpInfoRepository,
  appianIncomeInfoRepository,
  appianIdentityInfoRepository,
  createAddressRepository,
  accuityRepository,
  creditCCScoreRepository,
  insuranceRepository,
  customerExistRepository,
  referralDataRepository,
  accuitySupplementaryRepository,
  bankNamesRepository,
  crmContactValidateRepository,
  emailNotificationRepository,
  merchantNotificationRepository,
  automationApiRepository,
  autoLoanDetailsRepository,
  creditScorCalculationDigitalRepository
};
